






// LEGACY-V2-BRIDGE — TEMPORARIO, se borra con la v2.
import { getV3ConsoleUrl, signInWithUrlToken } from './v3Redirect';

export default {
	name: 'App',
	components: {},
	data() {
		return {
			loading: false,
			loadingText: this.$t('common.loading'),
			// LEGACY-V2-BRIDGE — TEMPORARIO: true mientras se cierra la sesión de una cuenta v3 que se va a la consola.
			leavingToV3: false,
		};
	},
	computed: {
		newUser() {
			return Object.keys(this.$store.state.newUser).length !== 0;
		},
	},
	mounted() {
		// LEGACY-V2-BRIDGE — TEMPORARIO: la consola de Rambox 3 manda acá, con `?token=`, a una cuenta enterprise que
		// sigue en v2 y llegó desde un link de campaña. El listener de abajo toma la sesión como cualquier otra.
		signInWithUrlToken(this.$firebase.auth());
		this.$firebase.auth().onAuthStateChanged(async user => {
			try {
				if (user) {
					if (this.newUser || this.$route.path === '/app/rambox') return (this.loading = false);
					this.loading = true;
					this.loadingText = this.$t('main.redirecting');
					// LEGACY-V2-BRIDGE — TEMPORARIO: una cuenta (u organización) que ya es de Rambox 3 se administra
					// desde la consola: se la manda ahí ya logueada en vez de dejar que checkAdmin la rechace con un
					// mensaje. Se cierra la sesión v2 antes de irse para que no quede viva en este origen.
					const v3ConsoleUrl = await getV3ConsoleUrl(await user.getIdToken(), '/home');
					if (v3ConsoleUrl) {
						this.leavingToV3 = true;
						await this.$firebase.auth().signOut();
						window.location.replace(v3ConsoleUrl);
						return;
					}
					const response = await this.$store.dispatch('authenticate', { user: user });
					this.loading = false;
					if (response.organizationId) this.$router.push(`/${response.organizationId}/_/dashboard`);
				} else {
					// LEGACY-V2-BRIDGE — TEMPORARIO: el signOut de arriba no tiene que mandar a `/`, ya nos estamos yendo.
					if (this.leavingToV3) return;
					this.loadingText = this.$options.data.call(this).loadingText;
					this.$route.meta.requiresAuth && (window.location.href = '/');
				}
				this.loading = false;
			} catch (error) {
				this.loading = false;
				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		});
	},
};
